import { render, staticRenderFns } from "./SimilarItemRecommendations.vue?vue&type=template&id=694928b8&scoped=true&"
import script from "./SimilarItemRecommendations.vue?vue&type=script&lang=js&"
export * from "./SimilarItemRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./SimilarItemRecommendations.vue?vue&type=style&index=0&id=694928b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694928b8",
  null
  
)

export default component.exports